// Admin API client — cookie-based auth (HTTP-only), same-origin via /api.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// On 401 during an authenticated session, try a single token refresh retry.
let refreshing = null;
client.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      !original._retried &&
      !original.url.includes('/admin/auth/')
    ) {
      original._retried = true;
      refreshing = refreshing || axios.post(
        `${API}/admin/auth/refresh`, {}, { withCredentials: true }
      ).finally(() => { refreshing = null; });
      try {
        await refreshing;
        return client(original);
      } catch {
        // refresh failed — caller handles the 401 (redirect to login)
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(err, fallback = 'Something went wrong. Please try again.') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg).filter(Boolean).join(' ');
  return fallback;
}

export default client;
